import ragul from "../assets/images/organisingSecretaries/ragulsiva.webp";
import divya from "../assets/images/organisingSecretaries/divyadarshan.jpg";
import john from "../assets/images/organisingSecretaries/ebhinjohnson.webp";
import thiru from "../assets/images/organisingSecretaries/thiruvikesh.jpg";
import ishva from "../assets/images/organisingSecretaries/ishva.webp";
import anu from "../assets/images/organisingSecretaries/anu.webp";

const OsDetails = [
  {
    name: "Anitha K",
    designation: "Organising Secretary",
    photo: anu,
    
  }, 
  {
    name: "Ebhin Johnson J",
    designation: "Organising Secretary",
    photo: john,
    linkedin: "https://www.linkedin.com/in/ebhin-johnson-j-17581b286/"
  },
  {
    name: "Divya Darshan V R",
    designation: "Organising Secretary",
    photo: divya,
    linkedin: "https://www.linkedin.com/in/divya-darshan-vr-2b4560289"
  },
  {
    name: "Ishva S",
    designation: "Organising Secretary",
    photo: ishva,
    linkedin: "http://www.linkedin.com/in/ishva-s"
  },
  {
    name: "Ragul S",
    designation: "Organising Secretary",
    photo: ragul,
    linkedin: "https://www.linkedin.com/in/ragul-s07/"
  }, 
  {
    name: "Thiruvikesh B",
    designation: "Organising Secretary",
    photo: thiru,
    linkedin: "https://www.linkedin.com/in/thiruvikeshb/",
  }
];

export default OsDetails;
